import React from "react";
import SEO from "./SEO";
import Breadcrumbs from "./Breadcrumbs";

// Shared chrome for legal pages: SEO, breadcrumb, title, last-updated, and a
// consistent prose container. `sections` = [{ heading, body: JSX }].
export default function LegalLayout({
  title,
  path,
  description,
  lastUpdated,
  intro,
  sections,
}) {
  return (
    <>
      <SEO title={title} description={description} path={path} />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: title }]} />

      <article className="container-page max-w-3xl py-12">
        <h1 className="text-4xl font-bold text-acblue sm:text-5xl">{title}</h1>
        {lastUpdated && (
          <p className="mt-3 text-sm text-acBlack/50">Last updated: {lastUpdated}</p>
        )}
        {intro && <p className="mt-6 text-lg text-acBlack/75">{intro}</p>}

        <div className="mt-10 space-y-10">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-xl font-bold text-acblue">
                {i + 1}. {s.heading}
              </h2>
              <div className="mt-3 space-y-3 text-acBlack/80 [&_a]:text-acAccent [&_a]:underline [&_li]:ml-1 [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:pl-5">
                {s.body}
              </div>
            </section>
          ))}
        </div>
      </article>
    </>
  );
}
